
function setProductTextWidth() {
    const imgCont = document.querySelector('.image-cont');
    const productTitles = document.querySelectorAll('.product-block__title_and_price');
    const productSubtitles = document.querySelectorAll('.product-block__subtitle');

    if (!imgCont) {
        return;
    }

    const imgContWidth = imgCont.offsetWidth;
    productTitles.forEach(title => {
        title.style.width = imgContWidth + 'px';
    });

    productSubtitles.forEach(subtitle => {
        subtitle.style.width = imgContWidth + 'px';
    });
}

window.addEventListener('load', setProductTextWidth);
window.addEventListener('resize', setProductTextWidth);
window.addEventListener('orientationchange', setProductTextWidth);

setProductTextWidth();

